export const API_URL = "https://api.quantumaxis.com.br/widgets/v1/";
export const API_SUBSCRIPTION_KEY = "e46ccdf619ef427baa0ef8c5037be4f0";
export const REDUX_PANE = false;
export const REDUX_LOGGER = false;
export const THEME = "default";
export const SHARE_URL = "default";
